import angular from 'angular';

import '../../core/main/filter/country/filter';
import '../../core/main/directive/email_address/directive'
import '../../core/main/directive/mailcheck/directive'
import '../../core/main/factory/analytics';
import './style.scss';

document.write(require('./view.html').default);

angular.module("merchant.application.page.resetAsk", [
]).controller("merchant.application.page.resetAsk.controller", [
    "$scope", "$controller", "$location", "$window",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.country",
    "core.application.main.controller.environment",
    "merchant.application.main.factory.okta",
    "core.application.main.factory.analytics",
    function($scope, $controller, $location, $window, Authentication, Country, Environment, Okta, Analytics) {
        $controller("merchant.application.page.controller", {$scope: $scope});

        var email = $location.search().e;
        var expired = $location.search().expired;
        $scope.model.reset = {};
        $scope.model.reset.fatalError = false;
        $scope.model.reset.submitted = false;
        $scope.model.reset.hasAsked = false;
        $scope.model.reset.expired = expired || false;
        if (email) {
            $scope.model.reset.email = email;
        }
        $scope.model.sso = {
            isSSOUser: false,
            enabled: false,
        };

        $scope.model.selectedCountry = {
            value: null
        };

        $scope.submit = function() {
            Analytics.sendAmplitudeEvent('Clicked the Submit button to reset password.')
            $scope.model.reset.submitted = true;
            $scope.model.reset.expired = false;
            if ($scope.form.$valid) {
                if (!$scope.model.sso.isSSOUser) {
                    $scope.sendEmail();
                } else {
                    $scope.goToSSOProvider();
                }
            }
        };

        $scope.sendEmail = function() {
            email = $scope.model.reset.email;
            if (email) {
                Authentication.saveResetAsk(email, function() {
                    $scope.model.reset.hasAsked = true;
                }, function() {
                    $scope.model.reset.fatalError = true;
                });
            }
        };

        $scope.setDefaultCountry = function() {
            var ii;
            $scope.model.countryCode = Country.getCountryCodeFromUrl();
            if ($scope.model.countryCode && $scope.model.countries && $scope.model.countries.length) {
                // set the default selected country based on the given country code
                for (ii = 0; ii < $scope.model.countries.length; ii++) {
                    if ($scope.model.countries[ii].countryCode === $scope.model.countryCode) {
                        $scope.model.selectedCountry.value = $scope.model.countries[ii];
                    }
                }
            }
        };

        $scope.onCountrySelected = function(item) {
            var ii;
            var redirectUrl = ""; // fallback to an internal domain redirection if we can't retrieve the portalUrl
            var selectedCountryCode = item && item.countryCode;
            // PAYL-8927 Retrieve the portal url that matches the selected country code
            for (ii = 0; ii < $scope.model.countries.length; ii++) {
                if ($scope.model.countries[ii].countryCode === selectedCountryCode) {
                    redirectUrl = $scope.model.countries[ii].portalUrl;
                }
            }

            // If the user has chosen a country code that's
            // different to the country code in the url, then they were
            // probably geosteered to the wrong country url path when
            // starting the process, so we need to redirect them to the
            // right place.
            // Redirecting to a different country from this page means
            // that the user could end up in a different region which
            // has different API endpoints and settings, so we need to
            // redirect them to the right region first to get the new
            // information from those endpoints.
            if (selectedCountryCode && selectedCountryCode !== Country.getCountryCodeFromUrl()) {
                // this redirect url assumes that the path for the user
                // merchant login email page is: /{countryCode}/merchant
                // and an optional next parameter
                // Great Britain (GB) should be the United Kingdom (UK) for the redirect url
                selectedCountryCode = selectedCountryCode === "GB" ? "UK" : selectedCountryCode;
                redirectUrl += "/" + selectedCountryCode.toLowerCase() + "/merchant" + $location.url();
                $window.location.href = redirectUrl;
            }
        };

        $scope.checkIsSSOEmail = function() {
            if(!$scope.model.sso.enabled) {
                $scope.model.sso.isSSOUser = false;
                return Promise.resolve(false);
            }
            return Okta.isEnabledForSSOLoginFlow($scope.model.reset.email)
                .then((isEnabled) => {
                    $scope.model.sso.isSSOUser = isEnabled;
                    return isEnabled;
                })
        };

        $scope.goToSSOProvider = function() {
            var countryCode = $scope.model.selectedCountry.value.countryCode.toLowerCase();
            Okta.login($scope.model.reset.email, $window.location.origin + '/' + countryCode + '/merchant/login')
        };

        Country.readCountries(null, function(response) {
            $scope.model.countries = response.countries;
            $scope.setDefaultCountry();
        });

        Okta.isFeatureEnabled().then((isEnabled) => {
            $scope.model.sso.enabled = isEnabled;
        });
    }
]);
